import { Facet } from "@linkfluence/models/facet";
import { FullFacet } from "@radarly/models/facets";

export interface ProductRepo {
  getProducts(project: number, facet: Facet): Promise<FullFacet["values"]>;
}

export const ProductRepositoryUID = Symbol("Radarly/ProductRepository");
